export default function findApplicableSeatingMapId(eventData, orderData) {
  let seatingMapId;
  if (orderData) {
    const { tickets } = orderData;
    const event = eventData;
    if (event.seatingMaps && tickets) {
      event.seatingMaps.forEach(seatingMap => {
        const isPublic = seatingMap.public !== false;
        seatingMap.ticketTypeSet.forEach(ticketType => {
          const containsPackageTicket =
            tickets.filter(
              ticket => String(ticket.packageId) === String(ticketType)
            ).length > 0;
          const containsTicketType =
            tickets.filter(
              ticket => String(ticket.ticketTypeId) === String(ticketType)
            ).length > 0;
          if (
            (containsPackageTicket || containsTicketType) &&
            !seatingMapId &&
            isPublic
          ) {
            seatingMapId = seatingMap.id;
          }
        });
      });
    }
  }
  return seatingMapId;
}



// WEBPACK FOOTER //
// ./utils/SeatingMapUtils.js